var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgUnlockedStatus = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M15.776 8a2.314 2.314 0 1 1 4.628 0v.804a.9.9 0 0 0 1.8 0v-.803a4.114 4.114 0 0 0-8.228 0v.267h1.8zM9.16 11.409h5.464c.603 0 1.092.489 1.092 1.092v3.857c0 .604-.489 1.093-1.092 1.093H9.16c-.603 0-1.092-.49-1.092-1.093V12.5c0-.603.489-1.092 1.092-1.092M6.268 12.5A2.893 2.893 0 0 1 9.16 9.608h5.464a2.893 2.893 0 0 1 2.893 2.892v3.857a2.893 2.893 0 0 1-2.893 2.893H9.16a2.893 2.893 0 0 1-2.892-2.893zm6.525 1.526a1.205 1.205 0 1 0-1.8-.001v2.01a.9.9 0 0 0 1.8 0z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnlockedStatus);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };